var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 5.66379H5.66379L5.66379 7.92672H4.75862L4.75862 5.66379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 16.0733H5.66379L5.66379 18.3362H4.75862L4.75862 16.0733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3362 16.0733H19.2414V18.3362H18.3362V16.0733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3362 10.6422H19.2414L19.2414 13.3578H18.3362L18.3362 10.6422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 10.6422H5.66379V13.3578H4.75862V10.6422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1897 4.75862H13.8103V5.66379H10.1897V4.75862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1897 18.3362L13.8103 18.3362L13.8103 19.2414L10.1897 19.2414L10.1897 18.3362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3362 5.66379H19.2414V7.92672H18.3362V5.66379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 4.75862L7.92672 4.75862L7.92672 5.66379L4.75862 5.66379V4.75862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 18.3362H7.92672V19.2414H4.75862V18.3362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0733 18.3362H19.2414V19.2414H16.0733L16.0733 18.3362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0733 4.75862L19.2414 4.75862V5.66379L16.0733 5.66379V4.75862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2L3.37931 2L3.37931 22H2L2 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6207 2L22 2L22 22H20.6207L20.6207 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37931 2L20.6207 2V3.37931L3.37931 3.37931V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37931 20.6207L20.6207 20.6207V22L3.37931 22L3.37931 20.6207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoi);
export default __webpack_public_path__ + "static/media/ROI.976eac99e26fece1e2df3c6508451b89.svg";
export { ForwardRef as ReactComponent };